<template>
    <div v-if="model">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-multiselect
                            :options="form.unidades"
                            :select-limit="null"
                            @update:dropdownClosed="handleUnidadeClosed"
                            label="Unidades"
                            option-name-key="nomeFantasia"
                            option-text-selecteds="unidade selecionado"
                            v-model="model.unidades"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-multiselect
                            :options="form.infraestruturas"
                            :select-limit="null"
                            @update:dropdownClosed="handleInfraestruturaClosed"
                            label="Locais de atendimento"
                            option-name-key="nome"
                            option-text-selecteds="local selecionado"
                            v-model="model.infraestruturas"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-multiselect
                            :options="form.usuarios"
                            :select-limit="null"
                            @update:dropdownClosed="handleUsuarioClosed"
                            label="Usuários"
                            option-name-key="nome"
                            option-text-selecteds="usuário selecionado"
                            v-model="model.usuarios"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-multiselect
                            :options="form.ocupacoes"
                            :select-limit="null"
                            @update:dropdownClosed="handleOcupacaoClosed"
                            label="CBO's"
                            option-name-key="nome"
                            option-text-selecteds="cbo selecionado"
                            v-model="model.ocupacoes"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-multiselect
                            :options="form.modulos"
                            :select-limit="null"
                            @update:dropdownClosed="handleModuloClosed"
                            label="Módulos"
                            option-name-key="nome"
                            option-text-selecteds="módulo selecionado"
                            v-model="model.modulos"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-multiselect
                            :options="form.funcionalidades"
                            :select-limit="null"
                            @update:dropdownClosed="handleFuncionalidadeClosed"
                            label="Funcionalidades"
                            option-name-key="nome"
                            option-text-selecteds="funcionalidade selecionada"
                            v-model="model.funcionalidades"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <template v-if="data">
            <rkm-area
                no-margin-top
                title="Resultado"
            >
                <template v-slot:trailing>
                    <rkm-button
                        @click="print"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>

                    <rkm-button
                        @click="exportTo"
                        color="info"
                        small
                        title="Exportar"
                    >
                        <rkm-icon icon="file-export" />
                    </rkm-button>
                </template>

                <rkm-table
                    :fields="fields"
                    :items="data.itens"
                    :sort-by="sortBy"
                    :sort-desc="sortDesc"
                    @sort-changed="onSortChanged"
                />
            </rkm-area>
        </template>
    </div>
</template>

<script>
// Mixins.
import {error, file, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    created() {
        this.repositories = {
            exportacao: this.getConectaSusRepository('exportacao.administracao'),
            impressao: this.getConectaSusRepository('impressao.administracao'),
            relatorioPermissaoLotacao: this.getConectaSusRepository('administracao.relatorioPermissaoLotacao'),
        }

        this.load()
    },
    data() {
        return {
            data: null,
            form: null,
            fields: [
                {key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true},
                {key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true},
                {key: 'usuarioNome', label: 'Usuário', sortable: true},
                {key: 'ocupacaoNome', label: 'CBO', sortable: true},
                {key: 'moduloNome', label: 'Módulo', sortable: true},
                {key: 'funcionalidadeNome', label: 'Funcionalidade', sortable: true},
            ],
            model: null,
            others: {moment},
            sortBy: 'unidadeNomeFantasia',
            sortDesc: false,
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioPermissaoLotacao.create()
                .then((response) => {
                    this.form = response.data.form
                    this.model = response.data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {
            const request = {
                unidades: this.model.unidades,
                infraestruturas: this.model.infraestruturas,
                usuarios: this.model.usuarios,
                ocupacoes: this.model.ocupacoes,
                modulos: this.model.modulos,
                funcionalidades: this.model.funcionalidades,
            }

            this.setLoading()

            this.repositories.relatorioPermissaoLotacao.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.data = Object.assign(response.data))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.data = null

            this.load()

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        print() {
            this.setLoading()

            const request = {
                unidades: this.model.unidades,
                infraestruturas: this.model.infraestruturas,
                usuarios: this.model.usuarios,
                ocupacoes: this.model.ocupacoes,
                modulos: this.model.modulos,
                funcionalidades: this.model.funcionalidades,
                sortBy: this.sortBy ? this.camelToSnake(this.sortBy) : null,
                sortDesc: this.sortDesc,
            }

            this.repositories.impressao.relatorioPermissaoLotacao(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {
            this.setLoading()

            const request = {
                unidades: this.model.unidades,
                infraestruturas: this.model.infraestruturas,
                usuarios: this.model.usuarios,
                ocupacoes: this.model.ocupacoes,
                modulos: this.model.modulos,
                funcionalidades: this.model.funcionalidades,
                sortBy: this.sortBy ? this.camelToSnake(this.sortBy) : null,
                sortDesc: this.sortDesc,
            }

            this.repositories.exportacao.relatorioPermissaoLotacao(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        handleUnidadeClosed() {
            this.data = null

            const request = {
                listar: 'infraestruturas',
                unidades: this.model.unidades,
            }

            this.setLoading()

            this.repositories.relatorioPermissaoLotacao.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.infraestruturas = response.data.infraestruturas
                    this.form.usuarios = response.data.usuarios
                    this.form.ocupacoes = response.data.ocupacoes
                    this.form.modulos = response.data.modulos
                    this.form.funcionalidades = response.data.funcionalidades
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleInfraestruturaClosed() {
            this.data = null

            const request = {
                listar: 'modulos',
                unidades: this.model.unidades,
                infraestruturas: this.model.infraestruturas,
            }

            this.setLoading()

            this.repositories.relatorioPermissaoLotacao.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.usuarios = response.data.usuarios
                    this.form.ocupacoes = response.data.ocupacoes
                    this.form.modulos = response.data.modulos
                    this.form.funcionalidades = response.data.funcionalidades
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUsuarioClosed() {
            this.data = null

            const request = {
                listar: 'ocupacoes',
                unidades: this.model.unidades,
                infraestruturas: this.model.infraestruturas,
                usuarios: this.model.usuarios,
            }

            this.setLoading()

            this.repositories.relatorioPermissaoLotacao.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.ocupacoes = response.data.ocupacoes
                    this.form.modulos = response.data.modulos
                    this.form.funcionalidades = response.data.funcionalidades
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleOcupacaoClosed() {
            this.data = null

            const request = {
                listar: 'modulos',
                unidades: this.model.unidades,
                infraestruturas: this.model.infraestruturas,
                usuarios: this.model.usuarios,
                ocupacoes: this.model.ocupacoes,
            }

            this.setLoading()

            this.repositories.relatorioPermissaoLotacao.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.modulos = response.data.modulos
                    this.form.funcionalidades = response.data.funcionalidades
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleModuloClosed() {
            this.data = null

            const request = {
                listar: 'funcionalidades',
                usuarios: this.model.usuarios,
                unidades: this.model.unidades,
                infraestruturas: this.model.infraestruturas,
                modulos: this.model.modulos,
            }

            this.setLoading()

            this.repositories.relatorioPermissaoLotacao.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.form.funcionalidades = response.data.funcionalidades)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleFuncionalidadeClosed() {
            this.data = null
        },
        onSortChanged(context) {
            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        },
    },
    mixins: [error, file, repository, stringCase],
}
</script>